export default __webpack_public_path__ + "static/media/carbiz-vector.de345bae.svg";